import {RouterProvider} from "react-router-dom";
import routes from "./router/routes";
import React, { useEffect } from 'react';
import {DownloadManagerProvider} from './contexts/DownloadManagerContext';
import {UserProvider} from './contexts/UserContext';
import AuthProvider from "./contexts/AuthContext";

const App = () => {
 
  return (
    <AuthProvider>
    <UserProvider>
        <DownloadManagerProvider>
        <RouterProvider router={routes}/>
        </DownloadManagerProvider>
    </UserProvider>
</AuthProvider>
  );
};

export default App;
